import { Constant } from "../../config";
import axios from "axios";
import { notification } from "antd";

export default {
  getBlackList: async (page = 1, limit = 10, search = "") => {
    const url =
      Constant.BLACKLIST_API +
      "?page=" +
      page +
      "&limit=" +
      limit +
      "&search=" +
      search;
    const opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    const d = resp.data.data;

    const output = {
      totalRows: resp.data.total_rows || 0,
      dataSource: d,
    };

    return output;
  },
  getAdminLists: async () => {
    let url = Constant.ADMIN_GETALL_API;

    let opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    const arrayAdminIds = [];
    for (const admin of resp.data.data) {
      arrayAdminIds.push(admin["id"]);
    }

    return { list: resp.data.data, adminIds: arrayAdminIds };
  },
  createBlackList: async (data) => {
    let url = Constant.BLACKLIST_API;

    let opt = {
      url,
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      data: data,
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return { error: resp.data.error };
    }

    return { error: false };
  },
  updateBlackList: async (data) => {
    let url = Constant.BLACKLIST_API;

    let opt = {
      url,
      method: "PATCH",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      data: data,
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return { error: resp.data.error };
    }

    return { error: false };
  },
  handlerError: (resp) => {
    let result = false;
    if (resp.error) {
      notification.error({
        message: resp.error.name,
        description: resp.error.description,
      });
    } else {
      result = true;
      notification.success({
        message: "การเพิ่มข้อมูลเสร็จสิ้น",
      });
    }

    return result;
  },
};



// WEBPACK FOOTER //
// ./src/containers/BlackList/services.js